import { parse } from 'hub-http/helpers/params';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
export const useQueryParams = () => {
  const {
    search
  } = useLocation();
  return useMemo(() => parse(search.substring(1)), [search]);
};